import { render, staticRenderFns } from "./Gaming.vue?vue&type=template&id=16c6fed6&"
import script from "./Gaming.vue?vue&type=script&lang=js&"
export * from "./Gaming.vue?vue&type=script&lang=js&"
import style0 from "./Gaming.vue?vue&type=style&index=0&id=16c6fed6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports